/**
 * Utility for RBAC (Role Based Access Control) checks.
 */

export const getRoleData = () => {
  try {
    const role = sessionStorage.getItem('role') || ''
    const namaRole = sessionStorage.getItem('nama_role') || ''
    const username = sessionStorage.getItem('username') || ''
    const idJenisRole = sessionStorage.getItem('id_jenis_role') || ''
    const idPeran = sessionStorage.getItem('id_peran') || ''
    const userStr = sessionStorage.getItem('user') || ''
    const user = userStr ? JSON.parse(userStr) : null
    const token = sessionStorage.getItem('token') || ''

    let tokenPayload = null
    if (token && token.includes('.')) {
      try {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''),
        )
        tokenPayload = JSON.parse(jsonPayload)
      } catch (e) {
        // ignore JWT decode error
      }
    }

    return {
      role,
      namaRole,
      username,
      idJenisRole,
      idPeran,
      user,
      tokenPayload,
    }
  } catch (e) {
    return {}
  }
}

export const isSuperAdmin = () => {
  const { role, namaRole, username, idJenisRole, idPeran, user, tokenPayload } =
    getRoleData()

  // Helper function to check if any string contains "superadmin"
  const hasSuperAdminText = (val) => {
    if (!val) return false
    return String(val).toLowerCase().includes('superadmin')
  }

  // 1. Check direct role name / username strings stored in sessionStorage
  if (hasSuperAdminText(namaRole)) return true
  if (hasSuperAdminText(role)) return true
  if (hasSuperAdminText(username)) return true

  // 2. Direct ID checks (0 = Superadmin)
  if (
    String(idJenisRole) === '0' ||
    String(idPeran) === '0' ||
    String(role) === '0'
  )
    return true

  // 3. Check user object stored in sessionStorage
  if (user && typeof user === 'object') {
    if (
      hasSuperAdminText(user.nama_role) ||
      hasSuperAdminText(user.role_name) ||
      hasSuperAdminText(user.nama_jenis_role) ||
      hasSuperAdminText(user.role) ||
      hasSuperAdminText(user.username) ||
      hasSuperAdminText(user.nama) ||
      hasSuperAdminText(user.nama_lengkap)
    ) {
      return true
    }

    const userRole =
      user.id_jenis_role ?? user.id_peran ?? user.role ?? user.role_id
    if (String(userRole) === '0') return true
    if (user.is_superadmin === 1 || user.is_superadmin === true) return true
  }

  // 4. Check JWT token payload fields
  if (tokenPayload && typeof tokenPayload === 'object') {
    if (
      hasSuperAdminText(tokenPayload.nama_role) ||
      hasSuperAdminText(tokenPayload.role_name) ||
      hasSuperAdminText(tokenPayload.nama_jenis_role) ||
      hasSuperAdminText(tokenPayload.role) ||
      hasSuperAdminText(tokenPayload.username) ||
      hasSuperAdminText(tokenPayload.name) ||
      hasSuperAdminText(tokenPayload.sub)
    ) {
      return true
    }

    const payloadRole =
      tokenPayload.id_jenis_role ??
      tokenPayload.id_peran ??
      tokenPayload.role ??
      tokenPayload.role_id
    if (String(payloadRole) === '0') return true
    if (tokenPayload.is_superadmin === 1 || tokenPayload.is_superadmin === true)
      return true
  }

  return false
}
